import axios from "axios";

import { baseURL } from "../../../utils/http/http-common";

export const getTeacherFinalAssessmentApiCall = async (teacherId) => {
  const authToken = localStorage.getItem("token");

  const response = await axios.get(
    `${baseURL}/FinalAssessment/GetFinalAssessmentTeacherData/${teacherId}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );

  if (!response?.data?.response) {
    throw new Error("Final assessment data unavailable");
  }

  return response;
};

export const downloadCertificateApiCall = async (teacherId) => {
  const authToken = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${baseURL}/FinalAssessment/DownloadCertificate/${teacherId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        responseType: "blob",
      }
    );

    return response;
  } catch (error) {
    return error?.config?.data;
  }
};
